import {axiosGet} from "../../../../common/Helper/AxiosHelper";
import {JOBPOSITION, SELECTABLE_JOB_POSITION} from "../../../../tenant/Config/ApiUrl";

const state =  {
    jobPosition: {},
    selectable: [],
    called: false
}

const actions = {
    getJobPositionDetails({commit, state}, jobPositionId){
        commit('SET_LOADER', true)
        axiosGet(`${JOBPOSITION}/${jobPositionId}`).then(({ data }) =>{
            commit('JOB_POSITION_DETAILS_DATA', data)
        }).finally(()=> commit('SET_LOADER', false))
    },
    getSelectableJobPositions({commit, state}) {
        if (!Object.keys(state.selectable).length && !state.called){
            commit('SET_CALLED', true);
            axiosGet(`${SELECTABLE_JOB_POSITION}`).then(({data}) => {
                commit('JOB_POSITION_LIST', data)
            });
        }
    }
}

const mutations = {
    JOB_POSITION_DETAILS_DATA(state, data){
        state.jobPosition = data;
    },
    JOB_POSITION_LIST(state, data) {
        state.selectable = data;
    },
    SET_CALLED(state, data) {
        state.called = data;
    }
}

export default {
    state,
    actions,
    mutations
}
